import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLimpieza} from '../../../../../hooks/useLimpieza'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'
import {creationCleaningActivitiesSchema} from '../../../schema/creationCleaningActivities'
import {yupResolver} from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import {
  CleaningActivitiesBodyModel,
  UpdateActivitySettingModel,
} from '../../../model/creationCleaningActivities.model'
import {CREATION_CLEANING_ACTIVITIES_SERVICES} from '../../../services/creation-cleaning-activities.service'
import {
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
} from '../../../../../util/Constants'
import {TabLimpiezaModel} from '../../../../../models'
import {ShowSnackBar} from '../../../../../util/functions'
import {funcDelete} from '../../../util/function'

const CreationCleaningActivitiesPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLimpieza()
  const [loading, setLoading] = useState(false)
  const methods = useForm<CleaningActivitiesBodyModel>({
    resolver: yupResolver(creationCleaningActivitiesSchema),
  })
  const {
    reset,
    formState: {errors},
  } = methods

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let ids = currentTabItem.selected || []
        let dto = {
          lstId: ids,
        }
        try {
          const data = await CREATION_CLEANING_ACTIVITIES_SERVICES.deleteActivitySetting(dto)
          if (!data.data.error) {
            const obj: TabLimpiezaModel = {
              ...currentTabItem,
              content: {
                ...currentTabItem.content,
                headerPanel: 'table-creation-of-cleaning-activities',
              },
              idToDelete: '',
              selected: [],
              loadingTable: true,
            }
            changeCurrentTabItem(obj)
            ShowSnackBar('Se eliminó con éxito')
          } else {
            ShowSnackBar(data.data.message, 'error')
          }
          setLoading(false)
        } catch (error) {
          setLoading(false)
          ShowSnackBar('Error interno', 'error')
        }

        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: CleaningActivitiesBodyModel) => {
    try {
      setLoading(true)
      const isCreating = !currentTabItem.idToEdit
      const updateDto: UpdateActivitySettingModel = {
        id: currentTabItem.idToEdit || '',
        MinutosPromedio: data.MinutosPromedio || 0,
        EstadoActividadId: data.EstadoActividadId || '',
      }
      const actividadTodos = data.ActividadId === 'TODOS' || data.ActividadId === '4EsB2NAAsDA='
      const response = isCreating
        ? await CREATION_CLEANING_ACTIVITIES_SERVICES.createCleaningActivity({
            ...data,
            ActividadId: actividadTodos ? null : data.ActividadId,
          })
        : await CREATION_CLEANING_ACTIVITIES_SERVICES.updateActivity(updateDto)

      if (!response.data.error) {
        methods.reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        if (isCreating) {
          console.log('response.data', response.data)
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            showPanel: true,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-creation-of-cleaning-activities',
              detailPanel: 'tab-creation-cleaning-activities',
            },
            idToEdit: response.data.ActivitySettingsId as string,
            loadingTable: true,
            currentExternalTab: 1,
          }
          changeCurrentTabItem(obj)
          ShowSnackBar(messageResponse)
        } else {
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            showPanel: false,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-creation-of-cleaning-activities',
            },
            idToEdit: '',
            loadingTable: true,
          }
          changeCurrentTabItem(obj)
          ShowSnackBar(messageResponse)
        }
      } else {
        ShowSnackBar(response.data.message ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
      setLoading(false)
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-creation-of-cleaning-activities'
          textComponentGo='form-creation-of-cleaning-activities'
          deleteButtonDisabled
          deleteButtonFunc={() => (currentTabItem.selected || [])?.length === 0}
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-limpieza-header-${currentTabItem.id}`}
              id={`panel-limpieza-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-limpieza-detail-${currentTabItem.id}`}
                    id={`panel-limpieza-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default CreationCleaningActivitiesPageWrapper
